import PropTypes from 'prop-types';
import pharmationLogoLight from 'assets/images/pharmation-logo-light.svg';
import pharmationLogoDark from 'assets/images/pharmation-logo-dark.svg';

// ==============================|| LOGO MAIN ||============================== //

export default function LogoMain({ dark = false }) {
  const logo = dark ? pharmationLogoDark : pharmationLogoLight;

  return (
    <svg
      viewBox="114 370 1284 665"
      style={{ width: '160px', height: 'auto', display: 'block' }}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <image href={logo} width="1500" height="1500" />
    </svg>
  );
}

LogoMain.propTypes = { dark: PropTypes.bool };
